import React, { useEffect, useState } from "react";
import { Row, Card, Button, Form, Col } from "react-bootstrap";
import { ErrorMessage, Field, Formik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createCategory, getCategoryById, updateCategory } from "../../../../services/CategoryService";

const AddCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [categoryData, setCategoryData] = useState({ name: ""});
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (id) {
      fetchCategoryDetails(id);
    } else {
      setCategoryData({ name: "" });
      setIsEditing(false);
    }
  }, [id]);

  const fetchCategoryDetails = async (categoryId) => {
    try {
      const category = await getCategoryById(categoryId);
      if (category) {
        
        setCategoryData(category);
        setIsEditing(true);
      }
    } catch (error) {
      console.error("Error fetching category details:", error);
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Name is required")
      .matches(/^[a-zA-Z0-9 ]*$/, "Name should not contain special characters"),
  });


  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const formattedValues = { "name": values.name.toLowerCase() };
      if (isEditing) {
        await updateCategory(id,formattedValues);
        toast.success("Category updated successfully!");
      } else {
        await createCategory(formattedValues);
        toast.success("Category added successfully!");
      }
      resetForm();
      navigate("/settings/skillcategory"); // Redirect to category list after submission
    } catch (error) {
      console.error("Error processing category:", error);
      toast.error("Error processing category!");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <Formik
        enableReinitialize
        initialValues={categoryData}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, handleSubmit, setFieldValue, isSubmitting }) => (
          <Form onSubmit={handleSubmit} className="p-4">
            <h4>{isEditing ? "Edit Category" : "Add Category"}</h4>
            <Card className="p-4">
              <Row className="mb-3">

              <Col>
                    <div className="form-group">
                      <label htmlFor="name">Category</label>
                      <Field
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Category"
                        value={values.name}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>

               

              </Row>
              <Row className="mt-3">
                <Col md={3} className="text-start">
                  <Link to="/settings/skillcategory">
                    <Button variant="danger" size="sm">
                      Cancel
                    </Button>
                  </Link>
                </Col>
                <Col className="text-end me-3">
                  <Button variant="success" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Processing..." : isEditing ? "Update" : "Submit"}
                  </Button>
                </Col>
              </Row>
            </Card>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddCategory;
